import { useEffect, useState, useCallback } from 'react'
import { UpDownToggleCSS } from './UpDownToggleCSS.styled'

interface UpDownToggleProps {
  game: string
  onToggle: (checked: boolean) => void
}

export const UpDownToggle: React.FC<UpDownToggleProps> = ({ game, onToggle }) => {
  const [checked, setChecked] = useState(false)

  const memoizedOnToggle = (value: boolean) => {
    onToggle(value)
  }

  useEffect(() => {
    memoizedOnToggle(checked)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked])

  return (
    <UpDownToggleCSS>
      <div className='pd_switch_wrapper'>
        <input type='checkbox' id={`pd_switch${game}`} checked={checked} onChange={() => setChecked(!checked)} />
        <div className='price_direction_switch'>
          <div className='pd_bg'>
            <div className='pd_content'>
              <label htmlFor={`pd_switch${game}`}>
                <div className='pd_toggle'></div>
                <div className='names'>
                  <p className='up'>
                    <span className='price_direction_icon up'></span>
                    Up
                  </p>
                  <p className='down'>
                    <span className='price_direction_icon down'></span>
                    Down
                  </p>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </UpDownToggleCSS>
  )
}
